var map = {
	"./$pac.svg": 22564,
	"./0xbtc.svg": 18645,
	"./2give.svg": 31984,
	"./aave.svg": 90573,
	"./abt.svg": 615,
	"./act.svg": 41177,
	"./actn.svg": 50623,
	"./ada.svg": 5663,
	"./add.svg": 4206,
	"./adx.svg": 50515,
	"./ae.svg": 99529,
	"./aeon.svg": 58185,
	"./aeur.svg": 80290,
	"./agi.svg": 83304,
	"./agrs.svg": 40058,
	"./aion.svg": 30714,
	"./algo.svg": 35498,
	"./amb.svg": 59670,
	"./amp.svg": 39230,
	"./ampl.svg": 63477,
	"./ankr.svg": 97786,
	"./ant.svg": 14239,
	"./apex.svg": 77992,
	"./appc.svg": 71512,
	"./ardr.svg": 14785,
	"./arg.svg": 44702,
	"./ark.svg": 40612,
	"./arn.svg": 92647,
	"./arnx.svg": 53375,
	"./ary.svg": 16113,
	"./ast.svg": 81209,
	"./atm.svg": 89156,
	"./atom.svg": 4058,
	"./audr.svg": 83127,
	"./auto.svg": 20696,
	"./avax.svg": 81291,
	"./aywa.svg": 64644,
	"./bab.svg": 17101,
	"./bal.svg": 82359,
	"./band.svg": 96507,
	"./bat.svg": 19255,
	"./bay.svg": 58896,
	"./bcbc.svg": 76168,
	"./bcc.svg": 67686,
	"./bcd.svg": 40189,
	"./bch.svg": 38020,
	"./bcio.svg": 63060,
	"./bcn.svg": 86031,
	"./bco.svg": 79573,
	"./bcpt.svg": 17619,
	"./bdl.svg": 26916,
	"./beam.svg": 81230,
	"./bela.svg": 35373,
	"./bix.svg": 13376,
	"./blcn.svg": 68055,
	"./blk.svg": 74449,
	"./block.svg": 37895,
	"./blz.svg": 9805,
	"./bnb.svg": 78764,
	"./bnt.svg": 38416,
	"./bnty.svg": 34188,
	"./booty.svg": 90113,
	"./bos.svg": 2459,
	"./bpt.svg": 93953,
	"./bq.svg": 49442,
	"./brd.svg": 65497,
	"./bsd.svg": 99947,
	"./bsv.svg": 80770,
	"./btc.svg": 60016,
	"./btcd.svg": 18689,
	"./btch.svg": 13373,
	"./btcp.svg": 6090,
	"./btcz.svg": 95110,
	"./btdx.svg": 49905,
	"./btg.svg": 7406,
	"./btm.svg": 72603,
	"./bts.svg": 45466,
	"./btt.svg": 60523,
	"./btx.svg": 76327,
	"./burst.svg": 70030,
	"./bze.svg": 77096,
	"./call.svg": 34619,
	"./cc.svg": 10356,
	"./cdn.svg": 97460,
	"./cdt.svg": 28363,
	"./cenz.svg": 51150,
	"./chain.svg": 85647,
	"./chat.svg": 72457,
	"./chips.svg": 40619,
	"./chsb.svg": 47448,
	"./cix.svg": 85249,
	"./clam.svg": 60781,
	"./cloak.svg": 79401,
	"./cmm.svg": 61820,
	"./cmt.svg": 45617,
	"./cnd.svg": 97451,
	"./cnx.svg": 42370,
	"./cny.svg": 49310,
	"./cob.svg": 32811,
	"./colx.svg": 88895,
	"./comp.svg": 34253,
	"./coqui.svg": 35941,
	"./cred.svg": 79151,
	"./crpt.svg": 1354,
	"./crv.svg": 22011,
	"./crw.svg": 42592,
	"./cs.svg": 46067,
	"./ctr.svg": 6636,
	"./ctxc.svg": 58723,
	"./cvc.svg": 39121,
	"./d.svg": 30337,
	"./dai.svg": 12297,
	"./dash.svg": 29203,
	"./dat.svg": 29366,
	"./data.svg": 8186,
	"./dbc.svg": 66929,
	"./dcn.svg": 45551,
	"./dcr.svg": 13783,
	"./deez.svg": 77385,
	"./dent.svg": 27367,
	"./dew.svg": 84427,
	"./dgb.svg": 26952,
	"./dgd.svg": 41297,
	"./dlt.svg": 51267,
	"./dnt.svg": 83717,
	"./dock.svg": 87113,
	"./doge.svg": 43442,
	"./dot.svg": 53748,
	"./drgn.svg": 7523,
	"./drop.svg": 25949,
	"./dta.svg": 19091,
	"./dth.svg": 37172,
	"./dtr.svg": 82601,
	"./dydx.svg": 51047,
	"./ebst.svg": 42236,
	"./eca.svg": 41510,
	"./edg.svg": 65929,
	"./edo.svg": 92192,
	"./edoge.svg": 62580,
	"./ela.svg": 49193,
	"./elec.svg": 64614,
	"./elf.svg": 3638,
	"./elix.svg": 14506,
	"./ella.svg": 13187,
	"./emb.svg": 49713,
	"./emc.svg": 68609,
	"./emc2.svg": 67763,
	"./eng.svg": 28210,
	"./enj.svg": 69515,
	"./entrp.svg": 7144,
	"./eon.svg": 51714,
	"./eop.svg": 40792,
	"./eos.svg": 92923,
	"./eqli.svg": 45177,
	"./equa.svg": 70660,
	"./etc.svg": 16900,
	"./eth.svg": 42436,
	"./ethos.svg": 24828,
	"./etn.svg": 60654,
	"./etp.svg": 25104,
	"./eur.svg": 863,
	"./evx.svg": 96723,
	"./exmo.svg": 38386,
	"./exp.svg": 24918,
	"./fair.svg": 75572,
	"./fct.svg": 66589,
	"./fil.svg": 10776,
	"./fjc.svg": 3046,
	"./fldc.svg": 86745,
	"./flo.svg": 20777,
	"./flux.svg": 46466,
	"./fsn.svg": 2341,
	"./ftc.svg": 54681,
	"./fuel.svg": 63575,
	"./fun.svg": 18175,
	"./game.svg": 55352,
	"./gas.svg": 12052,
	"./gbp.svg": 99139,
	"./gbx.svg": 7883,
	"./gbyte.svg": 10119,
	"./generic.svg": 46019,
	"./gin.svg": 71186,
	"./glxt.svg": 14994,
	"./gmr.svg": 10368,
	"./gno.svg": 90951,
	"./gnt.svg": 87451,
	"./gold.svg": 53041,
	"./grc.svg": 66205,
	"./grin.svg": 26300,
	"./grs.svg": 59505,
	"./grt.svg": 63112,
	"./gsc.svg": 3818,
	"./gto.svg": 59908,
	"./gup.svg": 84441,
	"./gusd.svg": 32157,
	"./gvt.svg": 81578,
	"./gxs.svg": 20707,
	"./gzr.svg": 91013,
	"./hight.svg": 62702,
	"./hns.svg": 21716,
	"./hodl.svg": 92468,
	"./hot.svg": 48471,
	"./hpb.svg": 84187,
	"./hsr.svg": 81805,
	"./ht.svg": 61488,
	"./html.svg": 66848,
	"./huc.svg": 25604,
	"./husd.svg": 16988,
	"./hush.svg": 75063,
	"./icn.svg": 1545,
	"./icp.svg": 47941,
	"./icx.svg": 5737,
	"./ignis.svg": 70933,
	"./ilk.svg": 34891,
	"./ink.svg": 58169,
	"./ins.svg": 91762,
	"./ion.svg": 83867,
	"./iop.svg": 12029,
	"./iost.svg": 5482,
	"./iotx.svg": 35173,
	"./iq.svg": 90373,
	"./itc.svg": 77264,
	"./jnt.svg": 491,
	"./jpy.svg": 63775,
	"./kcs.svg": 16543,
	"./kin.svg": 26718,
	"./klown.svg": 69989,
	"./kmd.svg": 80662,
	"./knc.svg": 19176,
	"./krb.svg": 79112,
	"./ksm.svg": 65222,
	"./lbc.svg": 6047,
	"./lend.svg": 20799,
	"./leo.svg": 43226,
	"./link.svg": 94388,
	"./lkk.svg": 20116,
	"./loom.svg": 97566,
	"./lpt.svg": 20011,
	"./lrc.svg": 14377,
	"./lsk.svg": 50153,
	"./ltc.svg": 86395,
	"./lun.svg": 7427,
	"./maid.svg": 47574,
	"./mana.svg": 36182,
	"./matic.svg": 58974,
	"./max.svg": 30151,
	"./mcap.svg": 3451,
	"./mco.svg": 82808,
	"./mda.svg": 3074,
	"./mds.svg": 67683,
	"./med.svg": 33600,
	"./meetone.svg": 92314,
	"./mft.svg": 51978,
	"./miota.svg": 26938,
	"./mith.svg": 54865,
	"./mkr.svg": 62220,
	"./mln.svg": 9544,
	"./mnx.svg": 82620,
	"./mnz.svg": 98109,
	"./moac.svg": 98322,
	"./mod.svg": 53103,
	"./mona.svg": 57158,
	"./msr.svg": 67760,
	"./mth.svg": 38471,
	"./mtl.svg": 14168,
	"./music.svg": 2596,
	"./mzc.svg": 47715,
	"./nano.svg": 14075,
	"./nas.svg": 44189,
	"./nav.svg": 10982,
	"./ncash.svg": 12099,
	"./ndz.svg": 97667,
	"./nebl.svg": 6425,
	"./neo.svg": 33033,
	"./neos.svg": 74326,
	"./neu.svg": 37048,
	"./nexo.svg": 7921,
	"./ngc.svg": 53563,
	"./nio.svg": 75047,
	"./nkn.svg": 19841,
	"./nlc2.svg": 79440,
	"./nlg.svg": 68591,
	"./nmc.svg": 83735,
	"./nmr.svg": 80949,
	"./npxs.svg": 41577,
	"./ntbc.svg": 88793,
	"./nuls.svg": 52671,
	"./nxs.svg": 30847,
	"./nxt.svg": 80936,
	"./oax.svg": 75309,
	"./ok.svg": 15103,
	"./omg.svg": 68827,
	"./omni.svg": 91311,
	"./one.svg": 30497,
	"./ong.svg": 8818,
	"./ont.svg": 76896,
	"./oot.svg": 17560,
	"./ost.svg": 30888,
	"./ox.svg": 82440,
	"./oxt.svg": 22990,
	"./part.svg": 40443,
	"./pasc.svg": 86435,
	"./pasl.svg": 50875,
	"./pax.svg": 67574,
	"./paxg.svg": 42663,
	"./pay.svg": 56217,
	"./payx.svg": 52617,
	"./pink.svg": 80796,
	"./pirl.svg": 5684,
	"./pivx.svg": 33745,
	"./plr.svg": 88554,
	"./poa.svg": 10685,
	"./poe.svg": 34855,
	"./polis.svg": 40346,
	"./poly.svg": 48283,
	"./pot.svg": 22759,
	"./powr.svg": 27199,
	"./ppc.svg": 8509,
	"./ppp.svg": 50477,
	"./ppt.svg": 32166,
	"./pre.svg": 83434,
	"./prl.svg": 68462,
	"./pungo.svg": 58128,
	"./pura.svg": 58318,
	"./qash.svg": 81931,
	"./qiwi.svg": 30014,
	"./qlc.svg": 59596,
	"./qrl.svg": 29904,
	"./qsp.svg": 90233,
	"./qtum.svg": 91907,
	"./r.svg": 15128,
	"./rads.svg": 48703,
	"./rap.svg": 2319,
	"./rcn.svg": 56914,
	"./rdd.svg": 21434,
	"./rdn.svg": 57385,
	"./ren.svg": 4748,
	"./rep.svg": 44083,
	"./repv2.svg": 52625,
	"./req.svg": 53706,
	"./rhoc.svg": 28232,
	"./ric.svg": 74390,
	"./rise.svg": 62091,
	"./rlc.svg": 19997,
	"./rpx.svg": 76374,
	"./rub.svg": 13026,
	"./rvn.svg": 33671,
	"./ryo.svg": 402,
	"./safe.svg": 8535,
	"./safemoon.svg": 56231,
	"./sai.svg": 52976,
	"./salt.svg": 38276,
	"./san.svg": 56748,
	"./sand.svg": 28030,
	"./sbd.svg": 70626,
	"./sberbank.svg": 74506,
	"./sc.svg": 16227,
	"./shift.svg": 49119,
	"./sib.svg": 24349,
	"./sin.svg": 58267,
	"./skl.svg": 8519,
	"./sky.svg": 4521,
	"./slr.svg": 72870,
	"./sls.svg": 43482,
	"./smart.svg": 25600,
	"./sngls.svg": 16351,
	"./snm.svg": 57671,
	"./snt.svg": 18903,
	"./snx.svg": 31370,
	"./soc.svg": 60235,
	"./sol.svg": 24270,
	"./spacehbit.svg": 30611,
	"./spank.svg": 71339,
	"./sphtx.svg": 29378,
	"./srn.svg": 73755,
	"./stak.svg": 89946,
	"./start.svg": 72171,
	"./steem.svg": 61449,
	"./storj.svg": 55294,
	"./storm.svg": 14229,
	"./stox.svg": 14441,
	"./stq.svg": 49153,
	"./strat.svg": 84659,
	"./stx.svg": 91771,
	"./sub.svg": 8517,
	"./sumo.svg": 47665,
	"./sushi.svg": 66370,
	"./sys.svg": 79748,
	"./taas.svg": 12232,
	"./tau.svg": 87663,
	"./tbx.svg": 46009,
	"./tel.svg": 70478,
	"./ten.svg": 88307,
	"./tern.svg": 8305,
	"./tgch.svg": 14825,
	"./theta.svg": 52955,
	"./tix.svg": 60281,
	"./tkn.svg": 18639,
	"./tks.svg": 21776,
	"./tnb.svg": 77271,
	"./tnc.svg": 45404,
	"./tnt.svg": 58064,
	"./tomo.svg": 38593,
	"./tpay.svg": 98261,
	"./trig.svg": 45007,
	"./trtl.svg": 81595,
	"./trx.svg": 76440,
	"./tusd.svg": 91728,
	"./tzc.svg": 8069,
	"./ubq.svg": 88663,
	"./uma.svg": 7080,
	"./uni.svg": 68676,
	"./unity.svg": 62470,
	"./usd.svg": 58688,
	"./usdc.svg": 27602,
	"./usdt.svg": 22698,
	"./utk.svg": 19895,
	"./veri.svg": 50715,
	"./vet.svg": 16497,
	"./via.svg": 53492,
	"./vib.svg": 75647,
	"./vibe.svg": 58752,
	"./vivo.svg": 65673,
	"./vrc.svg": 41101,
	"./vrsc.svg": 45247,
	"./vtc.svg": 76096,
	"./vtho.svg": 46058,
	"./wabi.svg": 36423,
	"./wan.svg": 29070,
	"./waves.svg": 54969,
	"./wax.svg": 17997,
	"./wbtc.svg": 53845,
	"./wgr.svg": 6342,
	"./wicc.svg": 4162,
	"./wings.svg": 98276,
	"./wpr.svg": 24626,
	"./wtc.svg": 93565,
	"./x.svg": 8265,
	"./xas.svg": 16790,
	"./xbc.svg": 20290,
	"./xbp.svg": 22949,
	"./xby.svg": 50701,
	"./xcp.svg": 43007,
	"./xdn.svg": 39542,
	"./xem.svg": 75894,
	"./xin.svg": 82130,
	"./xlm.svg": 37510,
	"./xmcc.svg": 15467,
	"./xmg.svg": 6604,
	"./xmo.svg": 77831,
	"./xmr.svg": 57111,
	"./xmy.svg": 20360,
	"./xp.svg": 47617,
	"./xpa.svg": 93656,
	"./xpm.svg": 79550,
	"./xpr.svg": 88154,
	"./xrp.svg": 84512,
	"./xsg.svg": 56700,
	"./xtz.svg": 31110,
	"./xuc.svg": 23999,
	"./xvc.svg": 73193,
	"./xvg.svg": 13547,
	"./xzc.svg": 47118,
	"./yfi.svg": 37958,
	"./yoyow.svg": 88336,
	"./zcl.svg": 67874,
	"./zec.svg": 71406,
	"./zel.svg": 78828,
	"./zen.svg": 25733,
	"./zest.svg": 89259,
	"./zil.svg": 18438,
	"./zilla.svg": 3124,
	"./zrx.svg": 81770
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20341;